var e;!function(e){e.PAUSED="paused",e.SUCCESS="success",e.ERROR="error",e.LOADING="loading",e.RESUME="resume",e.EDITING="editing",e.INIT="init"}(e||(e={}));export{e as FileState};
